module.exports = __webpack_public_path__ + "img/math.b2d47d0f.svg";